import React from "react"
import PropTypes from "prop-types"
import PrimaryButton from "newcomponents/primary-button"
import { BarChart } from "@mui/icons-material"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

const card = {
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  padding: 16,
  background: "#fff",
  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  height: "100%",
  minHeight: 210,
  transition: "box-shadow .18s ease, transform .18s ease",
}
const cardHover = {
  ...card,
  boxShadow: "0 6px 18px rgba(0,0,0,.08)",
  transform: "translateY(-1px)",
}

const header = {
  display: "flex",
  alignItems: "center",
  gap: 12,
}

const eyebrow = {
  fontSize: 11,
  color: "#6b7280",
  letterSpacing: ".08em",
  textTransform: "uppercase",
  fontWeight: 600,
}

const name = {
  fontSize: 18,
  color: "#111827",
  fontWeight: 700,
  lineHeight: 1.2,
  marginTop: 2,
  wordBreak: "break-word",
}

const grow = { flex: 1, minWidth: 0 }

const body = {
  marginTop: 12,
  paddingTop: 12,
  borderTop: "1px solid #eef2f7",
  display: "grid",
  gap: 10,
}

const row = {
  display: "grid",
  gridTemplateColumns: "160px 1fr",
  alignItems: "start",
  columnGap: 12,
  rowGap: 4,
}

const label = {
  fontSize: 12,
  color: "#6b7280",
  letterSpacing: ".02em",
  textTransform: "uppercase",
}

const value = {
  fontSize: 14,
  color: "#111827",
  wordBreak: "break-word",
}

const link = {
  color: "#2990DF",
  textDecoration: "underline",
  wordBreak: "break-all",
}

const DoctorCard = ({ doctor }) => {
  const navigate = useNavigate()
  const mode = useSelector(state => state.Layout.layoutMode)
  const { id, firstName, lastName, athenaDoctorId, email, googleReviewLink } =
    doctor || {}
  const fullName =
    [firstName, lastName].filter(Boolean).join(" ") || "Unknown Doctor"

  const reviewHref = googleReviewLink
    ? googleReviewLink.startsWith("http")
      ? googleReviewLink
      : `https://${googleReviewLink}`
    : null

  return (
    <div
      style={{ ...card, backgroundColor: mode === "dark" ? "#252f40" : "#fff" }}
    >
      {/* Header */}
      <div style={header}>
        <div style={grow}>
          <div style={eyebrow}>Doctor</div>
          <div style={{ ...name, color: mode === "dark" ? "#fff" : "#050409" }}>
            {fullName}
          </div>
        </div>

        <PrimaryButton
          aria-label="View performance"
          icon={<BarChart />}
          onClick={() => {
            navigate(`/dashboard/doctors/analysis/${id}`)
          }}
          style={{
            padding: "8px 12px",
            borderRadius: 10,
            whiteSpace: "nowrap",
          }}
        >
          Performance
        </PrimaryButton>
      </div>

      {/* Body */}
      <div style={body}>
        <div style={row}>
          <div style={label}>Athena Doctor ID</div>
          <div
            style={{ ...value, color: mode === "dark" ? "#fff" : "#111827" }}
          >
            {athenaDoctorId || "—"}
          </div>
        </div>

        <div style={row}>
          <div style={label}>Email</div>
          <div
            style={{ ...value, color: mode === "dark" ? "#fff" : "#111827" }}
          >
            {email ? <a href={`mailto:${email}`}>{email}</a> : "—"}
          </div>
        </div>

        <div style={row}>
          <div style={label}>Google Reviews</div>
          <div
            style={{ ...value, color: mode === "dark" ? "#fff" : "#111827" }}
          >
            {reviewHref ? (
              <a
                href={reviewHref}
                target="_blank"
                rel="noopener noreferrer"
                style={link}
              >
                Open reviews
              </a>
            ) : (
              "—"
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DoctorCard
